import { Fragment, useCallback } from 'react';
import { Skeleton } from '@material-ui/lab';
import moment from 'moment';
import { FEATURE } from '../../../utils/feature';
import useQueryParams from '../../../hooks/useQueryParams';
import useInlineHeight from '../../../hooks/useTabDetailsInlineHeight';
import PhoneIcon from '../../../assets/phone.svg';
import AsyncIcon from '../../../assets/contentPaste.svg';
import VideoIcon from '../../../assets/video.svg';
import { SEARCHED_ORDER, ORDERS_RESULT_COLUMN_SELECTOR, SEARCH_ORDERS_HEADING_SELECTOR } from '../../../constants/searchOrders.constant';
import { TAB_DETAILS_SCREEN_RESIZE_DELAY, PAGE_HEADING_SELECTOR, } from '../../../constants/patientChart.constant';
import './styles.scss';

export const DateFormat = 'YYYY-MM-DD';
export const MaxDate = moment().format(DateFormat);

const ModalityIconMap = new Map([
  [2, AsyncIcon],
  [1, PhoneIcon],
  [0, VideoIcon],
]);

const hasFeature = FEATURE();

export const ResultOrder = ({
  FirstName = '',
  LastName = '',
  ProductName = '',
  StoreFrontName = '',
  State = '',
  VisitType = 1,
  DOB = '',

  onVisit: handleVisit = () => {},
}) => (
  <div
    className='flex flex-fill justify-content-space-between p-2 border-box gap-8 min-width-280 max-width-280 border-2-dark-grey bg-white-v2 box-shadow-v1 pointer border-radius-2'
    onClick={handleVisit}
  >
    <div className='flex flex-column flex-fill gap-8'>
      <div className='font-roboto bold color-dark-primary-v2'>{FirstName} {LastName}</div>
      <div className='tracking-wide font-12'>{ProductName}: {StoreFrontName}</div>
      <div className='font-12 tracking-wide bold'>{State}</div>
      <div className='flex flex-fill align-items-flex-end justify-content-flex-end tracking-wide font-12'>{DOB}</div>
    </div>

    <div className='absolute top-2 right-2'>
      <img alt='modality' className='width-14' src={ModalityIconMap.get(VisitType)} />
    </div>
  </div>
);

export const ResultLoader = () => (
  <div
    className='flex flex-fill justify-content-space-between p-2 border-box gap-8 min-width-240 max-width-280 border-2-dark-grey bg-white-v2 box-shadow-v1 pointer border-radius-2'
  >
    <div className='flex flex-column flex-fill gap-8'>
      <Skeleton variant='text' width={160} />
      <Skeleton variant='text' width={240} />
      <Skeleton variant='text' width={100} />
    </div>
  </div>
);

export const SearchResult = ({
  history,
  location,
  searches = [SEARCHED_ORDER()],
  searchOrdersAPI = {},
}) => {
  /**
   * @description useQueryParams is used to read the version from query parameter
   */
  const { json: { version: queryVersion = 1 } } = useQueryParams({ location });

  const handleVisit = useCallback((data = SEARCHED_ORDER()) => {
    if (!data?.UserId) {
      return false;
    }

    if (!data?.OrderId) {
      return false;
    }

    if (hasFeature.PATIENT_CHART_V3 && queryVersion === 3) {
      history.push(`/patientchart-v3/${data.OrderId}/${data.UserId}`);
      return true;
    }

    if (hasFeature.PATIENT_CHART_V2) {
      history.push(`/patientchart/${data.OrderId}/${data.UserId}`);
    }
    return true;
  }, [history]);

  // needs a fix height
  useInlineHeight({
    tab: searches.length,
    delay: TAB_DETAILS_SCREEN_RESIZE_DELAY,
    selector: {
      targetElement: ORDERS_RESULT_COLUMN_SELECTOR,
    },
    totalNoOfGenericPaddings: 1,
    selectors: [
      PAGE_HEADING_SELECTOR,
      SEARCH_ORDERS_HEADING_SELECTOR,
    ],
  });

  const UICollection = new Map([
    ['true-true-true', () => (
      <div className='flex flex-wrap gap-24'>
        <ResultLoader />
      </div>
    )],
    ['true-true-false', () => (
      <div className='flex flex-wrap gap-24'>
        <ResultLoader />
      </div>
    )],
    ['true-false-true', () => (
      <div className='flex flex-wrap scroll-y-auto gap-24'>
        {searches.map((search) => <ResultOrder key={search.OrderId} onVisit={handleVisit.bind(this, search)} {...search} />)}
      </div>
    )],
    ['true-false-false', () => (
      <div className='flex flex-fill justify-content-center'>
        No orders found!
      </div>
    )],
    ['false-true-true', () => <Fragment />],
    ['false-true-false', () => <Fragment />],
    ['false-false-true', () => <Fragment />],
    ['false-false-false', () => <Fragment />],
  ]);

  const UI = UICollection.get(`${searchOrdersAPI.called}-${searchOrdersAPI.loading}-${searches.length > 0}`);

  return (
    <div className='search-orders-section-a-orders flex flex-column flex-fill'>
      <UI />
    </div>
  );
};

export default SearchResult;
